let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8c4Ih"), load("gYTHw"), load("5WfFg"), load("g9CVe"), load("diCLj")]).then(() => parcelRequire('7peIa'));